module.exports = __WEBPACK_EXTERNAL_MODULE_97__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 97
// module chunks = 0